module.exports = __webpack_public_path__ + "img/icon_4_24.8bcb1bfa.png";